import React, { useState } from 'react';
import { Box, Typography, Container, Grid, Button, Modal, Card, CardContent } from '@mui/material';
import roomImage2 from '../../images/videobackground.jpg';
import roomImage3 from '../../images/SEMBUWATTE 4.jpg';
import roomImage4 from '../../images/Jodu ella2.jpg';
import roomImage5 from '../../images/swiper5.jpg';
// import waterfall from '../../images/SAREE ELLA 1.jpg';
import waterfall1 from '../../images/HULUGANGA ELLA 1.jpg';
import waterfall2 from '../../images/SAREE ELLA2.jpg';
import { keyframes } from '@mui/system';

const fadeInSlideUp = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
  50% {
    opacity: 0.5;
    transform: translate(-50%, -10%);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`;

function SecFive() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        py: 8,
        px: { xs: 2, md: 4 },
      }}
    >
      <Container maxWidth="lg">
        {/* Header Section */}
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            textTransform: 'uppercase',
            fontSize: '0.9rem',
            letterSpacing: '0.2em',
            mb: 1,
            color: '#6c757d',
          }}
        >
          WELCOME TO KNUCKLES WATERFALL ADVENTURE
        </Typography>
        <Typography
          variant="h4"
          sx={{
            textAlign: 'center',
            fontFamily: "'Playfair Display', serif",
            fontWeight: '600',
            fontSize: { xs: '2rem', md: '2.5rem' },
            mb: 3,
            color: '#000',
          }}
        >
          Discover Hidden Waterfalls in the Knuckles Mountain Range
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            fontSize: '1rem',
            lineHeight: 1.8,
            color: '#6c757d',
            maxWidth: '700px',
            mx: 'auto',
            mb: 4,
          }}
        >
          Embark on an unforgettable adventure in the breathtaking Knuckles Mountain Range, a hidden gem of paradise filled with stunning waterfalls nestled within lush forest canopies.

          Join us for a day of exploration, where our experienced chauffeur will guide you in a comfortable 4x4 jeep to discover these enchanting waterfalls. Capture the mesmerizing beauty of nature, from cascading falls to lush greenery.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
          <Button
            variant="contained"
            onClick={handleOpen}
            sx={{
              backgroundColor: '#556B2F',
              color: '#fff',
              textTransform: 'uppercase',
              px: 4,
              py: 1,
              '&:hover': {
                backgroundColor: '#6B8E23',
              },
            }}
          >
            Explore More
          </Button>
        </Box>

        {/* Modal Popup */}
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '90%',
              maxWidth: '1000px',
              bgcolor: 'rgba(255, 255, 255, 0.2)', // Semi-transparent background
              color: '#fff',
              borderRadius: '8px',
              p: 4,
              overflowY: 'auto',
              maxHeight: '90vh',
              backdropFilter: 'blur(5px)', // Blurs the background
              WebkitBackdropFilter: 'blur(10px)', // Safari compatibility
            }}

          >
            <Box sx={{ textAlign: 'right', mb: 2 }}>
              <Button
                variant="contained"
                onClick={handleClose}
                sx={{
                  backgroundColor: '#556B2F',
                  color: '#fff',
                  px: 3,
                  py: 1,
                  '&:hover': {
                    backgroundColor: '#6B8E23',
                  },
                }}
              >
                Close
              </Button>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 4,
              }}
            >
              {/* Huluganaga Falls Card */}
              <Card
                sx={{
                  width: '300px',
                  boxShadow: 4,
                  borderRadius: '8px',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                  }}
                  src={waterfall1}
                  alt="Huluganaga Falls"
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "'Playfair Display', serif",
                      fontWeight: '600',
                      textAlign: 'center',
                      mb: 1,
                    }}
                  >
                    Huluganaga Falls
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                    Huluganaga Falls, standing at 75 meters, is the tallest waterfall in the Knuckles Range.
                    Known for its stunning beauty and serene surroundings, it is a perfect spot for
                    photography, picnics, and enjoying lush greenery.
                  </Typography>
                </CardContent>
              </Card>

              {/* Saree Ella Falls Card */}
              <Card
                sx={{
                  width: '300px',
                  boxShadow: 4,
                  borderRadius: '8px',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                  }}
                  src={waterfall2}
                  alt="Saree Ella Falls"
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "'Playfair Display', serif",
                      fontWeight: '600',
                      textAlign: 'center',
                      mb: 1,
                    }}
                  >
                    Saree Ella Falls
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                    Saree Ella Falls, with a height of 20 meters, resembles a saree’s pallu. The wide lower
                    cascade and upper stripe create a beautiful flow, showcasing breathtaking views
                    particularly when in full flow.
                  </Typography>
                </CardContent>
              </Card>

              {/* Jodu Ella Falls Card */}
              <Card
                sx={{
                  width: '300px',
                  boxShadow: 4,
                  borderRadius: '8px',
                  overflow: 'hidden',
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: '100%',
                    height: '200px',
                    objectFit: 'cover',
                  }}
                  src={roomImage4}
                  alt="Jodu Ella Falls"
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "'Playfair Display', serif",
                      fontWeight: '600',
                      textAlign: 'center',
                      mb: 1,
                    }}
                  >
                    Jodu Ella Falls
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                    Jodu Ella Falls, standing at 45 meters, features twin horsetail streams depicted on Sri
                    Lanka’s 100 Rupee note. The iconic view and tranquil surroundings make it a must-see
                    destination.
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          </Box>
        </Modal>


        {/* Content Section */}
        <Grid container spacing={4} sx={{ position: 'relative' }}>
          {/* Vertical Line */}
          <Box
            sx={{
              position: 'absolute',
              width: '2px',
              height: '100%',
              backgroundColor: '#d9d9d9',
              left: '50%',
              transform: 'translateX(-50%)',
              display: {
                xs: 'none', // Hides on extra-small screens (mobile)
                sm: 'none', // Hides on small screens (tablet)
                md: 'block', // Shows on medium and larger screens (desktop)
              },
            }}
          ></Box>

          {/* Add Images as before */}
          {/* Left Top Image */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'right', pr: { md: 4 } }}>
            <Box
              component="img"
              src={roomImage4}
              alt="Wonderful Waterfalls "
              sx={{
                width: '70%',
                height: '500px',
                objectFit: 'cover',
                // borderRadius: '8px',
                mb: 2,
                ml: 'auto',
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontSize: '0.9rem',
                color: '#6c757d',
                // textAlign: "center"
              }}
            >
              • Jodu Ella
            </Typography>
          </Grid>

          {/* Right Top Image */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'left', pl: { md: 4 } }}>
            <Box
              component="img"
              src={roomImage2}
              alt="Self-guided Walking Tours"
              sx={{
                width: '80%',
                height: '300px',
                objectFit: 'cover',
                // borderRadius: '8px',
                mb: 2,
                mt: 10
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontSize: '0.9rem',
                color: '#6c757d',
                // textAlign: "center"

              }}
            >
              • 4x4 jeep Tours
            </Typography>
          </Grid>

          {/* Left Bottom Image */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'right', pr: { md: 4 }, mt: 1 }}>
            <Box
              component="img"
              src={roomImage3}
              alt="Perfect Picnic Settings"
              sx={{
                width: '80%',
                height: '300px',
                objectFit: 'cover',
                // borderRadius: '8px',
                mb: 2,
                ml: 'auto',
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontSize: '0.9rem',
                color: '#6c757d',
              }}
            >
              • Sembuwatta Lake
            </Typography>
          </Grid>

          {/* Right Bottom Image */}
          <Grid item xs={12} md={6} sx={{ textAlign: 'left', pl: { md: 4 }, mt: -2 }}>
            <Box
              component="img"
              src={roomImage5}
              alt="Blueberry Picking Experience"
              sx={{
                width: '70%',
                height: '600px',
                objectFit: 'cover',
                // borderRadius: '8px',
                mb: 2,
              }}
            />
            <Typography
              variant="body1"
              sx={{
                fontSize: '0.9rem',
                color: '#6c757d',
              }}
            >
              • Knuckles Iconic View
            </Typography>
          </Grid>

          {/* Continue with other images */}
        </Grid>
      </Container>
    </Box>
  );
}

export default SecFive;
